module.exports = __webpack_public_path__ + "static/media/registrationSuccess.7f89498b.svg";